import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Config } from "../../../config/api.config";
import { Responsibility, ResponsibilityRequest } from "../responsibility.model";
import { PagedResponse } from "@app/models/paged-response";

@Injectable({
  providedIn: "root",
})
export class ResponsibilitiesService {
  constructor(private http: HttpClient) {}

  public findAll(): Observable<Responsibility[]> {
    return this.http.get<Responsibility[]>(`${Config.webApiUrl}/v1/responsibility`);
  }

  public findAllPaged(page: number, size: number, sort?: string, direction?: string): Observable<PagedResponse<any>> {
    let params = new HttpParams().set("page", page).set("size", size);
    if (sort) {
      params = params.set("sort", `${sort},${direction || "asc"}`);
    }
    return this.http.get<PagedResponse<any>>(`${Config.webApiUrl}/v1/responsibility/paged`, { params });
  }

  public findByOffice(officeId: String): Observable<Responsibility[]> {
    return this.http.get<Responsibility[]>(`${Config.webApiUrl}/v1/office/${officeId}/responsibilities`);
  }

  public findById(responsibilityId: string): Observable<Responsibility> {
    return this.http.get<Responsibility>(`${Config.webApiUrl}/v1/responsibility/${responsibilityId}`);
  }

  public create(responsibility: ResponsibilityRequest): Observable<Responsibility> {
    return this.http.post<Responsibility>(`${Config.webApiUrl}/v1/responsibility`, responsibility);
  }

  public update(id: string, responsibility: ResponsibilityRequest): Observable<Responsibility> {
    return this.http.put<Responsibility>(`${Config.webApiUrl}/v1/responsibility/${id}`, responsibility);
  }

  public delete(id: string): Observable<Responsibility> {
    return this.http.delete<Responsibility>(`${Config.webApiUrl}/v1/responsibility/${id}`);
  }
}
